import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import { connect } from 'react-redux';
import { withError } from './with-error';

function getNativeShareHandler(canNativeShare, title, fullUrl) {
  if (!canNativeShare) {
    return null;
  }

  return function handleShare() {
    window.navigator.share({
      title: title,
      url: fullUrl
    })["catch"](console.error);
  };
}

var SocialShareBase = /*#__PURE__*/function (_React$Component) {
  _inherits(SocialShareBase, _React$Component);

  var _super = /*#__PURE__*/_createSuper(SocialShareBase);

  function SocialShareBase(props) {
    var _this;

    _classCallCheck(this, SocialShareBase);

    _this = _super.call(this, props);
    _this.state = {
      canNativeShare: false
    };
    return _this;
  }

  _createClass(SocialShareBase, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        canNativeShare: global && global.navigator && global.navigator.share
      });
    }
  }, {
    key: "render",
    value: function render() {
      var fullUrl = this.props.fullUrl || "".concat(this.props.publisherUrl, "/").concat(this.props.url);
      var hashtags = this.props.hashtags ? this.props.hashtags : '';
      return /*#__PURE__*/React.createElement(this.props.template, Object.assign({
        fbUrl: "https://www.facebook.com/sharer.php?u=".concat(encodeURIComponent(fullUrl)),
        twitterUrl: "https://twitter.com/intent/tweet?url=".concat(encodeURIComponent(fullUrl), "&text=").concat(encodeURIComponent(this.props.title), "&hashtags=").concat(hashtags),
        gplusUrl: "https://plus.google.com/share?url=".concat(encodeURIComponent(fullUrl)),
        linkedinUrl: "https://www.linkedin.com/shareArticle?url=".concat(encodeURIComponent(fullUrl), "&title=").concat(encodeURIComponent(this.props.title)),
        whatsappUrl: "https://api.whatsapp.com/send?text=".concat(encodeURIComponent(fullUrl)),
        mailtoUrl: "mailto:".concat("?subject=", encodeURIComponent(this.props.title), "&body=").concat(encodeURIComponent(fullUrl)),
        redditUrl: "https://www.reddit.com/submit?url=".concat(encodeURIComponent(fullUrl), "&title=").concat(encodeURIComponent(this.props.title), "&type=LINK"),
        handleNativeShare: getNativeShareHandler(this.state.canNativeShare, this.props.title, fullUrl)
      }, this.props));
    }
  }]);

  return SocialShareBase;
}(React.Component);

function mapStateToProps(state) {
  return {
    publisherUrl: state.qt.config['sketches-host']
  };
}
/**
 * This component renders social share component to front end app.
 *
 * Example
 * ```javascript
 * import { SocialShare } from '@quintype/components';
 *
 * class CustomComponent extends React.Component {
 *   getSocialCardsTemplate({fbUrl, twitterUrl, gplusUrl, linkedinUrl, handleNativeShare}) {
 *     return <ul className="social-share-icons">
 *        <li className="social-share-icon">
 *          <a href={fbUrl} target="_blank">
 *            <img src={fbIcon} alt="fb icon"/>
 *          </a>
 *        </li>
 *        {handleNativeShare && <li className="social-share-icon">
 *          <button onClick={handleNativeShare}>
 *            <img src={fbIcon} alt="share icon"/>
 *          </button>
 *        </li>}
 *      </ul>
 *   }
 *
 *   render() {
 *     return <div className="story-byline__social-share">
 *       <SocialShare fullUrl={this.props.story.url}
 *         title='Headline of the story'
 *         template={this.getSocialCardsTemplate}
 *         hashtags='news,india,press' />
 *     </div>
 *   }
 * }
 * ```
 *
 * @component
 * @category Story Page
 */


export var SocialShare = /*#__PURE__*/connect(mapStateToProps, {})( /*#__PURE__*/withError(SocialShareBase));